<div class="container-fluid px-0">
  <div class="row my-0 mx-0">
    <nz-tabset [(nzSelectedIndex)]="tabIndex">
      <nz-tab>
        <pa-first-tab [card]="card" (indexChange)="pageIndexChange($event)" (transferLimit)="transferLimitChange($event)"></pa-first-tab>
      </nz-tab>
      <nz-tab>
        <pa-second-tab [transferLimit]="transferLimit"></pa-second-tab>
      </nz-tab>
    </nz-tabset>

  </div>
</div>
